
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrainingStats"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrainingStats"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiredRelevantVotesRemainingCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requiredNotRelevantVotesRemainingCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"votesUntilTriggerTrainingCount"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":156}};
    doc.loc.source = {"body":"fragment TrainingStats on TrainingStats {\n  requiredRelevantVotesRemainingCount\n  requiredNotRelevantVotesRemainingCount\n  votesUntilTriggerTrainingCount\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
